// extracted by mini-css-extract-plugin
export default {"store-register-box":"StoreRegister_store-register-box__hkmu8","img-container":"StoreRegister_img-container__P15Pg","img-left":"StoreRegister_img-left__xU8bz"};